import { render } from "./PrincipalComponent.vue?vue&type=template&id=476a69e6&scoped=true&ts=true"
import script from "./PrincipalComponent.vue?vue&type=script&lang=ts"
export * from "./PrincipalComponent.vue?vue&type=script&lang=ts"

import "./PrincipalComponent.vue?vue&type=style&index=0&id=476a69e6&lang=css&scoped=true"

import exportComponent from "C:\\Users\\Ronnald\\Desktop\\page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-476a69e6"]])

export default __exports__